import { ComponentProps, MouseEvent, ReactElement } from 'react';

import { Warning as WarningIcon } from '@mui/icons-material';
import { Box } from '@mui/material';

import { ConfirmationModal } from '@/components/modals';

type DeleteEmailTemplateDialogProps = Required<
  Pick<ComponentProps<typeof ConfirmationModal>, 'open' | 'onClose'>
> & {
  isPending: boolean;
  onConfirm: () => void;
};

export const DeleteEmailTemplateDialog = (
  props: DeleteEmailTemplateDialogProps,
): ReactElement => {
  const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
    if (props.isPending) return;
    props.onClose(event, 'backdropClick');
  };

  return (
    <ConfirmationModal
      open={props.open}
      isPending={props.isPending}
      onClose={handleClose}
      title="Delete this template?"
      content={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          You will not be able to recover this once deleted.
        </Box>
      }
      cancelActionTitle="Cancel"
      confirmActionTitle="Yes"
      onConfirm={props.onConfirm}
      onCancel={handleClose}
    />
  );
};
